import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { InsertControlGroupMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

type InsertControlGroupInput = {
  Title: string;
  Description: string;
  Owner: string;
  CustomAttributeData?: CustomAttributeData | null;
};

export const useInsertControlGroupTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.controlGroup.insert.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.controlGroup.controlGroups.queryKey(),
        });

        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.controlGroup.controlGroupById.queryKey(),
        });

        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.controlGroup.controlGroupsByTitle.queryKey(),
        });
      },
    }),
  });

  return {
    insertControlGroup: async (
      variables: InsertControlGroupInput
    ): Promise<InsertControlGroupMutation> => {
      const result = await mutation.mutateAsync(variables);

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};

function mapTrpcResponseToGraphQL(trpcData: {
  Id: string;
}): InsertControlGroupMutation {
  return {
    insert_control_group_one: {
      __typename: 'control_group',
      Id: trpcData.Id,
    },
  };
}
